// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterMobile_root__dWlOX","copyright":"FooterMobile_copyright__oK0Re"};